import React from 'react';
import { Button, Tooltip } from 'antd';
import { ButtonProps } from 'antd/lib/button';
import useComponentConfiguration from 'DisplayFramework/useComponentConfiguration';
import { ApiTwoTone } from '@ant-design/icons';

export type AssetMoveButtonProps = Omit<ButtonProps, 'icon'> & {
  comcode: string;
  twoToneColor: string;
  onlyicon?:boolean;
};

const AssetMoveButton = ({
  comcode,
  twoToneColor,
  onlyicon,
  ...otherProps
}: AssetMoveButtonProps) => {
  const { label, hint } = useComponentConfiguration(comcode);
  return (
    <Tooltip title={hint}>
      <Button
        icon={<ApiTwoTone color="blue" height="17px" width="16px"/>}
        {...otherProps}
      >
        {!onlyicon?label:null}
      </Button>
    </Tooltip>
  );
};

export default AssetMoveButton;
